import { render } from "./uploadList.vue?vue&type=template&id=ef9e17b2&scoped=true"
import script from "./uploadList.vue?vue&type=script&lang=js"
export * from "./uploadList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9e17b2"]])

export default __exports__